import { rescueModalUiButtonSubtextSchema } from "@redotech/redo-model/checkouts/predictive-conversion-settings";
import * as z from "zod/v4";

export const updateConversionSettings = {
  name: "updateConversionSettings" as const,
  input: z.object({
    teamId: z.string(),
    checkoutOptimizationEnabled: z.boolean(),
    predictiveConversion: z.object({
      enabled: z.boolean(),
      intentRequested: z.boolean(),
      rescueModalAdminSettings: z.object({
        uiButtonSubtext: rescueModalUiButtonSubtextSchema,
      }),
    }),
    postPurchaseUpsell: z.object({ createOrderOnUpsell: z.boolean() }),
    ensureDiscountsCombineWithShippingDiscounts: z.boolean(),
  }),
  output: z.null(),
};
